module.exports = __webpack_public_path__ + "img/2024-12-12d_3.8c1e4b55.jpg";